import type React from 'react';

function SvenskaHemIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 69.6 69.6"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Svenska Hem Icon</title>

      <g id="Lager_1-2" data-name="Lager 1">
        <g>
          <path d="M69.3,0H0V66.2H69.6V0s-.3,0-.3,0Zm-.3,.6V65.5H.6V.6H69ZM7.4,30.2c0,1,.5,2.8,3.7,2.8,.8,0,3.4-.2,3.4-2.7,0-1.5-1.1-1.9-2.3-2.2l-2.1-.5c-.4-.1-.9-.2-.9-.9s.8-1,1.5-1c1.6,0,1.7,.9,1.8,1.2h1.7c0-1-.7-2.7-3.3-2.7-2.8,0-3.3,1.6-3.3,2.5,0,1.8,1.3,2.1,2.7,2.4l.9,.2c.9,.2,1.6,.4,1.6,1,0,.9-.9,1.1-1.8,1.1-1.6,0-1.8-.9-1.8-1.3,0,0-1.8,.1-1.8,.1Zm10.8,.5h0l-1.8-6.3h-2l2.9,8.3h1.7l2.9-8.3h-1.8l-1.9,6.3Zm10.7-6.3h-6.2v8.3h6.5v-1.5h-4.8v-2.1h4.2v-1.5h-4.2v-1.7h4.5s0-1.5,0-1.5Zm6.5,5.8h0l-3.4-5.8h-1.9v8.3h1.7v-5.9l3.5,5.9h1.8v-8.3h-1.7v5.8Zm2.4,0c0,1,.5,2.8,3.7,2.8,.7,0,3.4-.2,3.4-2.7,0-1.5-1.1-1.9-2.2-2.2l-2.1-.5c-.4-.1-.9-.2-.9-.9s.8-1,1.5-1c1.6,0,1.7,.9,1.8,1.2h1.7c0-1-.7-2.7-3.3-2.7-2.8,0-3.3,1.6-3.3,2.5,0,1.8,1.3,2.1,2.7,2.4l.9,.2c.9,.2,1.6,.4,1.6,1,0,.9-.9,1.1-1.8,1.1-1.6,0-1.8-.9-1.8-1.3,0,0-1.9,.1-1.9,.1Zm9.6-.3l.8-.8,2.7,3.6h2.3l-3.7-4.9,3.5-3.4h-2.3l-3.3,3.4v-3.4h-1.8v8.3h1.8v-2.8Z" />
          <path
            d="M55.9,31h3.2l.5,1.7h1.9l-3-8.3h-2.1l-3.1,8.3h1.9s.7-1.7,.7-1.7Zm1.6-4.7h0l1.1,3.3h-2.2s1.1-3.3,1.1-3.3Z"
            fillRule="evenodd"
          />
        </g>
        <path
          d="M19.6,45.8v8.9h4.2v-19.9h-4.2v7.6h-7.9v-7.6H7.6v19.9h4.1v-8.9s7.9,0,7.9,0Zm20.8-11h-14.8v19.9h15.2v-3.5h-11.1v-5.2h9.8v-3.5h-9.8v-4.1h10.7v-3.6Zm21.2,0h-6.1l-3.5,15.7h-.1l-3.6-15.7h-6.1v19.9h3.9v-16.6l3.7,16.6h4.1l3.7-16.6h.1v16.6h3.9s0-19.9,0-19.9ZM24.9,11.5h18.5v3.3H24.9v-3.3Z"
          fill="#d70911"
        />
      </g>
    </svg>
  );
}

export default SvenskaHemIcon;
